export default __webpack_public_path__ + "static/media/1.b505417b.jpg";